// ##############################
// // // Footer styles
// #############################

import {
  container,
  primaryColor,
  btnLink
} from "assets/jss/material-kit-pro-react.jsx";

const footerStyle = {
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right"
  },
  rightLinks: {
    float: "right!important",
    "& ul": {
      marginBottom: 0,
      marginTop: 10,
      padding: 0,
      listStyle: "none",
      height: 38,
      "& li": {
        display: "inline-block"
      }
    },
    "& i": {
      fontSize: "1.25rem"
    }
  },
  footer: {
    padding: "0.9375rem 0",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative",
    "& ul": {
      marginBottom: "0",
      padding: 0,
      listStyle: "none"
    }
  },
  big: {
    padding: "1.875rem 0",
    "& h5, & h4": {
      fontWeight: 700,
      marginBottom: "15px"
    },
    "& p": {
      color: "#999"
    }
  },
  content: {
    textAlign: "left"
  },
  a: {
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  dark: {
    background: "radial-gradient(ellipse at center,#585858 0,#232323 100%)",
    backgroundSize: "550% 450%",
    color: "#fff",
    "& p": {
      color: "#999"
    },
    "& i": {
      color: "#fff"
    },
    "& a": {
      color: "#fff",
      opacity: ".86",
      "&:visited": {
        color: "#fff"
      },
      "&:focus, &:hover": {
        opacity: 1
      }
    },
    "& hr": {
      borderColor: "rgba(255,255,255,0.2)"
    },
    "& $btnTwitter, & $btnDribbble, & $btnInstagram": {
      color: "#fff"
    }
  },
  white: {
    backgroundColor: "#fff",
    color: "#0A2733",
    textDecoration: "none",
    "& a": {
      "&:visited": {
        color: "#0A2733"
      },
      "&:hover, &:focus": {
        color: "#89229b"
      }
    }
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "1.2rem",
    height: "1.2rem",
    position: "relative",
    top: "3px"
  },
  iconSocial: {
    width: "3rem",
    height: "3rem",
    fontSize: "1.5rem",
    minWidth: "3rem",
    padding: 0,
    overflow: "hidden",
    position: "relative"
  },
  btnTwitter: {
    ...btnLink,
    color: "#55acee"
  },
  btnDribbble: {
    ...btnLink,
    color: "#ea4c89"
  },
  btnInstagram: {
    ...btnLink,
    color: "#125688"
  },
  footerBrand: {
    height: "50px",
    padding: "15px 15px",
    fontSize: "1.125rem",
    lineHeight: "50px",
    marginLeft: "-15px",
    color: "#0A2733",
    textDecoration: "none",
    fontWeight: 700,
  },
  pullCenter: {
    display: "inline-block",
    float: "none"
  },
  clearFix: {
    clear: "both"
  }
};
export default footerStyle;
